import React from 'react';

export function preloadableLazy(factory) {
  let loaded = null;
  const Component = React.lazy(() => {
    if (loaded) return loaded;
    loaded = factory();
    return loaded;
  });
  Component.preload = () => {
    if (!loaded) loaded = factory();
    return loaded;
  };
  return Component;
} 